module.exports = __webpack_public_path__ + "media/images/redesign-images/contract/contract-sales-02-7a914e4d0373fcad6da8d209cf42552d.svg";